export default function progressBar() {
  const percent = $('[data-percent]');
  const number = '[data-percentnumber]';
  const item = '[data-percentitem]';
  const inprogress = '[data-inprogress]';
  const active = 'active';
  const completed = 'completed';

  percent.each((index, el) => {
    const elNumber = $(el).data('percent');
    $(el).find(number).text(elNumber);
    if ($(el).data('percent') > 0) {
      $(el).closest(item).addClass(active);
      $(el).closest(item).find(inprogress).css('width', elNumber + '%');
    }
    if ($(el).data('percent') == 100) {
      $(el).closest(item).addClass(completed);
    }
  })
  
}